import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
    Box,
    Button,
    Container,
    Divider,
    FormControl,
    FormControlLabel,
    Modal,
    Radio,
    RadioGroup,
    Stack,
    Typography,
} from "@mui/material";
import { default as React, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    useGetAssignmentMasterMutation,
    useGetAssignmentQuestionListMutation,
    useGetAssignmentQuestionListByIdMutation,
    usePostAssignmentSubmissionMutation,
    usePostAssignmentTrackEndMutation,
    useGetAssignmentTrackListMutation,
} from "../../apiSlice";
import SideBar from "../Dashboard/StudentDashboard/Sidebar/SideBar";
import Breadcrumb from "../StudentBreadcrumb/Breadcrumb";

const AssignmentContent = () => {
    const navigate = useNavigate();

    const [courseData] = useState(() =>
        JSON.parse(sessionStorage.getItem("courseData") || "{}")
    );
    const [assignmentData, setAssignmentData] = useState();
    const [trackList, setTrackList] = useState();
    const [assignmentQuestionList, setAssignmentQuestionList] = useState([]);
    const [numberOfAssignmentQuestions, setNumberOfAssignmentQuestions] =
        useState(1);
    const [submitToggle, setSubmitToggle] = useState(true);
    const [loadingToggle, setLoadingToggle] = useState(false);
    const [open, setOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [selectedAnswers, setSelectedAnswers] = useState({});
    const [assignmentUserAnswerSelections, setAssignmentUserAnswerSelections] =
        useState([]);

    // API Mutation Functions
    const [studentAssignmentMasterAPI] = useGetAssignmentMasterMutation();
    const [studentAssignmentQuestionListAPI] =
        useGetAssignmentQuestionListMutation();
    const [studentAssignmentQuestionListByIdAPI] =
        useGetAssignmentQuestionListByIdMutation();
    const [submitUserAssignmentResponseAPI] =
        usePostAssignmentSubmissionMutation();
    const [studentAssignmentTrackListAPI] = useGetAssignmentTrackListMutation();
    const [assignmentTrackEndAPI] = usePostAssignmentTrackEndMutation();

    const fetchAssignmentId = () => {
        return Number(localStorage.getItem("assignmentID"));
    };

    // Assignment Master API Calling UseEffects are present here --------------------------------

    useEffect(() => {
        const fetchAssignmentMaster = async () => {
            try {
                const trackList = await studentAssignmentTrackListAPI(
                    courseData.courseId
                );
                setTrackList(trackList.data);

                const response = await studentAssignmentMasterAPI();

                // Current Assignemnt ID fetched from the Local Storage
                const assignmentID = fetchAssignmentId();

                const refCurrentAssignmentData = response?.data.filter(
                    (assignment) => assignment.assignmentId === assignmentID
                )[0];

                setAssignmentData(refCurrentAssignmentData);
            } catch (e) {
                console.log("ERROR: ", e);
            }
        };

        fetchAssignmentMaster();
    }, []);

    // ------------------------------------------------------------------------

    // Assignment Question List API Calling UseEffects are present here --------------------------------

    useEffect(() => {
        const fetchAssignmentQuestionList = async () => {
            try {
                // Current Assignemnt ID fetched from the Local Storage
                const assignmentID = fetchAssignmentId();

                const response = await studentAssignmentQuestionListByIdAPI(
                    assignmentID
                );

                const refAssignmentQuestions = response?.data || [];

                setNumberOfAssignmentQuestions(refAssignmentQuestions?.length);
                setAssignmentQuestionList(refAssignmentQuestions);
            } catch (e) {
                console.log("ERROR: ", e);
            }
        };

        fetchAssignmentQuestionList();
    }, []);

    // ------------------------------------------------------------------------

    // For checking if the value is setting the State Variable "currentAssignemntData"
    useEffect(() => {
        console.log("assignmentData === ", assignmentData);
    }, [assignmentData]);

    // For checking if the value is setting the State Variable "assignmentQuestionList"
    useEffect(() => {
        console.log("assignmentQuestionList ===== ", assignmentQuestionList);
    }, [assignmentQuestionList]);

    // For checking if the value is setting the State Variable "selectedAnswers"
    useEffect(() => {
        console.log("selectedAnswers ===== ", selectedAnswers);
    }, [selectedAnswers]);

    // For checking if the value is setting the State Variable "assignmentQuestionList"
    useEffect(() => {
        console.log(
            "assignmentUserAnswerSelections ===== ",
            assignmentUserAnswerSelections
        );
    }, [assignmentUserAnswerSelections]);

    /**
     * Handles the state of the answers selected
     *
     * @param {number} questionId - The ID of the assignment question being answered.
     * @param {string} answer - The selected option value
     */
    const handleAnswerSelect = (questionId, answer) => {
        setSelectedAnswers((prev) => ({
            ...prev,
            [questionId]: answer,
        }));
    };

    /**
     * Handles the selection of an answer for an assignment question.
     *
     * This function performs the following:
     * 1. Updates the selected radio option state using `handleAnswerSelect`.
     * 2. Updates the state `assignmentUserAnswerSelections`:
     *    - If the question ID does not already exist in the state, it adds a new object.
     *    - If it does exist, it updates the `assignmentUserAnswer` value for the matching question.
     *
     * @param {string} selection - The selected option value
     * @param {number} asgnId - The ID of the assignment.
     * @param {number} asgnQuestionId - The ID of the assignment question being answered.
     */
    const handleAssignmentAnswerSelection = (
        selection,
        asgnId,
        asgnQuestionId
    ) => {
        /**
         * Handling the Radio Options state
         */
        handleAnswerSelect(asgnQuestionId, selection);

        /**
         * For testing purpose of only
         */
        // console.log(
        //     `selection: ${selection}, asgnId: ${asgnId}, asgnQuestionId: ${asgnQuestionId}`
        // );

        // Setting the User Selected value & generating obj for "Assignment Submission Reponse"
        setAssignmentUserAnswerSelections((prev) => {
            /**
             * Checking if the Assignment Question alread exists
             *      - If already exists that means, it has been answered
             */
            const exist = prev.some(
                (asgn) => asgn.assignmentQuestionId === asgnQuestionId
            );

            /**
             * If the question does not already exists in the state, it means:
             *      - This is the "1st" question being answered, or
             *      - This is a new question that hasn't been answered yet
             *
             * In both cases, append the new answer objects with the state Array.
             */
            if (!exist) {
                return [
                    ...prev,
                    {
                        assignmentId: asgnId,
                        assignmentQuestionId: asgnQuestionId,
                        assignmentUserAnswer: selection,
                    },
                ];
            }

            /**
             * Handles the update case
             *
             * If the question is answered and the users chooses other option for it then,
             *      - We are finding that question in our state, then
             *      - Update the newly answered value in the "assignmentUserAnswer" key-value pair
             */
            return prev.map((asgn) =>
                asgn.assignmentQuestionId === asgnQuestionId
                    ? {
                          ...asgn,
                          assignmentUserAnswer: selection,
                      }
                    : asgn
            );
        });
    };

    const handleSubmit = async () => {
        try {
            setLoadingToggle(true);

            console.log(
                ">>>>>>>>>>> handle submit for Assignment Quiz <<<<<<<<<<"
            );
            // const trackId = trackList?.filter( (tl) => tl.isAssignmentCompleted === false
            // )?.assignmentTrackId;

            // console.log("TRACKID >>>>>>>>> ", trackId);

            // await assignmentTrackEndAPI({
            //     assignmentTrackId: trackId,
            // });

            // console.log(
            //     ">>>>>>>>>>> handle submit for Assignment Quiz <<<<<<<<<<"
            // );
            const userResponse = assignmentUserAnswerSelections;

            const response = await submitUserAssignmentResponseAPI(
                userResponse
            ).unwrap();

            if (response?.response === "SUCCESS") {
                setOpen(true);
            } else {
                setIsError(true);
                setOpen(true);
            }

            console.log("Submission Response: ", response);
        } catch (err) {
            console.error("Submission error:", err);
        } finally {
            // setLoading((prev) => ({ ...prev, submission: false }));
            setLoadingToggle(false);
        }
    };

    /**
     * Handles the Submit Button Toggle Logic
     */
    useEffect(() => {
        /**
         * Early return to prevent false toggling during initial loading
         */
        if (
            assignmentUserAnswerSelections.length === 0 ||
            assignmentQuestionList.length === 0
        )
            return;

        /**
         * Toggling if the length of User Answered array and the question list array are equal
         */
        if (
            assignmentUserAnswerSelections.length ===
            assignmentQuestionList.length
        ) {
            setSubmitToggle(false);
        } else {
            setSubmitToggle(true);
        }
    }, [assignmentUserAnswerSelections, assignmentQuestionList]);

    return (
        <>
            <SideBar />
            <Box
                sx={{
                    // flexGrow: 1,
                    position: "relative",
                    width: "calc(100vw - 60px)",
                    padding: "20px",
                    height: "100vh",
                    left: "60px",
                    backgroundColor: "#F8F9FD",
                    // border: "2px solid red",
                }}
            >
                {/* BreadCrumb Container */}
                <Box
                    sx={
                        {
                            // border: "2px solid yellow",
                        }
                    }
                >
                    <Breadcrumb />
                </Box>
                {/* Assignment Answer Selection Container */}
                <Box
                    sx={{
                        // border: "2px solid green",
                        height: "90%",
                        paddingY: "20px",
                    }}
                >
                    <Box
                        sx={{
                            border: "1px solid #DDDDDD",
                            width: "80%",
                            height: "100%",
                            backgroundColor: "white",
                            borderRadius: "10px",
                            padding: "20px",
                            margin: "10px auto",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "start",
                            alignContent: "center",
                        }}
                    >
                        <Box
                            sx={{
                                border: "1px solid #DDDDDD",
                                width: "80%",
                                backgroundColor: "white",
                                borderRadius: "10px",
                                padding: "20px",
                                margin: "10px auto",
                            }}
                        >
                            <Typography
                                variant="h3"
                                sx={{
                                    fontWeight: 700,
                                    mb: "5px",
                                }}
                            >
                                {assignmentData?.assignmentTittle ||
                                    "Sample Assignment Title"}
                            </Typography>
                            <Typography variant="body2">
                                {assignmentData?.assignmentDescription ||
                                    "Sample Assignment Description"}
                            </Typography>
                        </Box>
                        <Box
                            className="w"
                            sx={{
                                flex: "1",
                                border: "1px solid #DDDDDD",
                                width: "80%",
                                height: "100%",
                                backgroundColor: "white",
                                borderRadius: "10px",
                                padding: "20px",
                                margin: "10px auto",
                                overflowY: "scroll",
                            }}
                        >
                            {/* {Array(100).fill(0).map((_, idx) => (
                                <p className="">
                                    askjdflkasjfdkj
                                </p>
                            ))} */}

                            {numberOfAssignmentQuestions != 0 ? (
                                assignmentQuestionList?.map((question, idx) => (
                                    // {/* Single Question Card */}
                                    <Box
                                        key={idx}
                                        sx={{
                                            bgcolor: "background.paper",
                                            border: "2px solid #DDDDDD",
                                            p: 3,
                                            borderRadius: 2,
                                            boxShadow: 1,
                                            width: "100%",
                                            mx: "auto",
                                            mb: "20px",
                                        }}
                                    >
                                        <Typography variant="h5" gutterBottom>
                                            {/* {currentQuestion.quizQuestion} */}
                                            {idx + 1}.{" "}
                                            {question.assignmentQuestion1}
                                        </Typography>

                                        <FormControl
                                            component="fieldset"
                                            sx={{ mt: 2, width: "100%" }}
                                        >
                                            <RadioGroup
                                                value={
                                                    selectedAnswers[
                                                        question
                                                            .assignmenQuestionId
                                                    ] || ""
                                                }
                                                onChange={(e) => {
                                                    handleAssignmentAnswerSelection(
                                                        e.target.value,
                                                        question.assignmentId,
                                                        question.assignmenQuestionId
                                                    );
                                                }}
                                            >
                                                {[1, 2, 3, 4].map((optNum) => (
                                                    <FormControlLabel
                                                        key={optNum}
                                                        value={
                                                            question[
                                                                `assignmentOption${optNum}`
                                                            ]
                                                        }
                                                        control={<Radio />}
                                                        // onClick={() => {
                                                        //     assignmentUserAnswerSelections.length ===
                                                        //     assignmentQuestionList.length
                                                        //         ? setSubmitToggle(
                                                        //               false
                                                        //           )
                                                        //         : setSubmitToggle(
                                                        //               true
                                                        //           );
                                                        // }}
                                                        label={
                                                            question[
                                                                `assignmentOption${optNum}`
                                                            ]
                                                        }
                                                        sx={{
                                                            mb: 1,
                                                            p: 1,
                                                            borderRadius: 1,
                                                            "&:hover": {
                                                                bgcolor:
                                                                    "#f5f5f5",
                                                            },
                                                        }}
                                                    />
                                                ))}
                                            </RadioGroup>
                                        </FormControl>
                                    </Box>
                                ))
                            ) : (
                                <Box
                                    sx={{
                                        width: "100%",
                                        height: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        color: "#f2424b",
                                        fontWeight: 700,
                                        fontSize: 16,
                                        textAlign: "center",
                                    }}
                                >
                                    <Typography color="secondary">
                                        No questions available. Please contact
                                        your school administrator for
                                        assistance.
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => {
                                            navigate(-1);
                                        }}
                                        sx={{
                                            px: "60px",
                                            mt: "20px",
                                        }}
                                    >
                                        Go Back
                                    </Button>
                                </Box>
                            )}
                        </Box>
                        <Container
                            disableGutters
                            maxWidth="false"
                            sx={{
                                // border: "2px solid blue",
                                width: "80%",
                                display: "flex",
                                justifyContent: "end",
                                alignContent: "center",
                                gap: "10px",
                            }}
                        >
                            <Button
                                variant="contained"
                                color="success"
                                // onClick={handleOpen}
                                onClick={handleSubmit}
                                disabled={submitToggle}
                                loading={loadingToggle}
                            >
                                Submit Assignment
                            </Button>
                        </Container>
                        <ModalComp
                            open={open}
                            navigate={navigate}
                            isError={isError}
                            assignmentData={assignmentData}
                            assignmentQuestionList={assignmentQuestionList}
                            assignmentUserAnswerSelections={
                                assignmentUserAnswerSelections
                            }
                        />
                    </Box>
                </Box>
            </Box>
        </>
    );
};

const ModalComp = ({
    open,
    navigate,
    isError,
    assignmentData,
    assignmentQuestionList,
    assignmentUserAnswerSelections,
}) => {
    console.log(
        assignmentData,
        assignmentQuestionList,
        assignmentUserAnswerSelections
    );

    //     [
    //     {
    //         "assignmentId": 2,
    //         "assignmentQuestionId": 3,
    //         "assignmentUserAnswer": "Op2"
    //     },
    // ]

    // [
    //     {
    //         "assignmenQuestionId": 3,
    //         "assignmenQuestion": "Name the process by which plants prepare food ",
    //         "assignmenQuestionType": "Long Answer",
    //         "assignmentId": 2,
    //         "assignmentTittle": "Science",
    //         "assignmentCorrectAnswer": "Photosynthesis",
    //         "assignmentOption1": "Op1",
    //         "assignmentOption2": "Op2",
    //         "assignmentOption3": "Op3",
    //         "assignmentOption4": "Op4"
    //     },
    // ]

    const calculateScore = () => {
        let score = 0;

        assignmentUserAnswerSelections.forEach((userAnswer) => {
            let question = assignmentQuestionList.find(
                (question) =>
                    question.assignmenQuestionId ===
                    userAnswer.assignmentQuestionId
            );

            if (
                question &&
                question.assignmentCorrectAnswer ===
                    userAnswer.assignmentUserAnswer
            )
                score++;
        });

        return score;
    };

    const totalPossibleScore = assignmentData?.assignmentTotalPoints;
    const totalScore = calculateScore();
    const assignmentPercentage = Math.round(
        (totalScore / totalPossibleScore) * 100
    );

    return (
        <>
            {isError ? (
                <Modal
                    open={open}
                    // onClose={setOpen(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: 450,
                            bgcolor: "background.paper",
                            borderRadius: 3,
                            boxShadow: 10,
                            p: 4,
                            outline: "none",
                            maxHeight: "80vh",
                            overflowY: "auto",
                        }}
                    >
                        <Typography
                            id="modal-modal-title"
                            variant="h4"
                            component="h2"
                            sx={{
                                color: "red",
                            }}
                        >
                            Please connect with admin
                        </Typography>
                        <Button
                            variant="contained"
                            color="success"
                            onClick={() => {
                                navigate(
                                    "/StudentDashboard/Course/CourseContent"
                                );
                            }}
                            sx={{
                                width: "100%",
                                mt: "20px",
                            }}
                        >
                            Continue the Course
                        </Button>
                    </Box>
                </Modal>
            ) : (
                <Modal
                    open={open}
                    // onClose={setOpen(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "70%",
                            bgcolor: "background.paper",
                            borderRadius: 3,
                            boxShadow: 10,
                            p: 4,
                            outline: "none",
                            maxHeight: "80vh",
                            overflowY: "auto",
                        }}
                    >
                        <Typography variant="h4" gutterBottom align="center">
                            Assignment Results
                        </Typography>
                        <Typography variant="h5" gutterBottom align="center">
                            Score: {totalScore}/{totalPossibleScore} points
                            {/* Score: 60/100 points */}
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            align="center"
                            gutterBottom
                        >
                            {assignmentPercentage + "%"}
                        </Typography>

                        <Divider sx={{ my: 3 }} />

                        {assignmentUserAnswerSelections.map(
                            (userAnswer, idx) => {
                                const currentAssignment =
                                    assignmentQuestionList.find(
                                        (question) =>
                                            question?.assignmenQuestionId ===
                                            userAnswer?.assignmentQuestionId
                                    );

                                const isCorrect =
                                    currentAssignment?.assignmentCorrectAnswer ===
                                    userAnswer?.assignmentUserAnswer;

                                return (
                                    <Box key={idx} sx={{ mb: 3 }}>
                                        <Stack
                                            direction="row"
                                            alignItems="flex-start"
                                            spacing={1}
                                        >
                                            {isCorrect ? (
                                                <CheckCircleIcon
                                                    color="success"
                                                    sx={{ mt: 0.5 }}
                                                />
                                            ) : (
                                                <CancelIcon
                                                    color="error"
                                                    sx={{ mt: 0.5 }}
                                                />
                                            )}
                                            <Box sx={{ flexGrow: 1 }}>
                                                <Typography
                                                    variant="h6"
                                                    component="div"
                                                >
                                                    Question {idx + 1}:{" "}
                                                    {
                                                        currentAssignment.assignmenQuestion
                                                    }
                                                </Typography>

                                                <Box sx={{ ml: 2, mt: 1 }}>
                                                    <Typography>
                                                        <strong>
                                                            Your answer:
                                                        </strong>{" "}
                                                        <span
                                                            style={{
                                                                color: isCorrect
                                                                    ? "#4caf50"
                                                                    : "#f44336",
                                                            }}
                                                        >
                                                            {
                                                                userAnswer.assignmentUserAnswer
                                                            }
                                                        </span>
                                                    </Typography>
                                                    {!isCorrect && (
                                                        <Typography>
                                                            <strong>
                                                                Correct answer:
                                                            </strong>{" "}
                                                            {
                                                                currentAssignment.assignmentCorrectAnswer
                                                            }
                                                        </Typography>
                                                    )}
                                                    <Typography>
                                                        <strong>Points:</strong>{" "}
                                                        <span
                                                            style={{
                                                                color: isCorrect
                                                                    ? "#4caf50"
                                                                    : "#f44336",
                                                            }}
                                                        >
                                                            {isCorrect ? 1 : 0}
                                                            /1
                                                        </span>
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Stack>

                                        <Divider sx={{ mt: 2 }} />
                                    </Box>
                                );
                            }
                        )}
                        <Button
                            variant="contained"
                            color="success"
                            onClick={() => {
                                navigate(
                                    "/StudentDashboard/Course/CourseContent"
                                );
                            }}
                            sx={{
                                width: "100%",
                                mt: "20px",
                            }}
                        >
                            Continue the Course
                        </Button>
                    </Box>
                </Modal>
            )}
        </>
    );
};

export default AssignmentContent;
